import React from 'react';
import SelfServiceSystem from '../../components/SelfServiceSystem';

const Token = () => (
  <>
    <SelfServiceSystem />
  </>
);

export default Token;
